import { Flex, SystemStyleObject, Text } from '@chakra-ui/react'
import React from 'react'

interface ReferButtonProps {
  sx?: SystemStyleObject
  buttonText: string
  onClick: () => void
}
export const ReferButton = ({ sx, buttonText, onClick }: ReferButtonProps) => {
  return (
    <Flex sx={sx} className="refer-call-button" onClick={onClick}>
      <Text>{buttonText}</Text>
    </Flex>
  )
}
